import Config from '../../utils/Config';

class TapToOpen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid    : uuid()
        };

        this.componentDidMount = this.componentDidMount.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
    }

    componentDidMount() {
        $('.project').on('scroll', this.onScroll);
        $(window).resize(this.onResize);

        this.onResize();
    }

    componentWillUnmount() {
        $('.project').off('scroll', this.onScroll);
        $(window).off('resize', this.onResize);
    }

    onScroll() {

    }

    onResize() {
        var w = $(window).width();
        var h = $(window).height();

        var left = 0;
        var top = 450;

        if  (w > 1270) {
            left = (w / 2) - (1270 / 2);

            if (top < 500)
                top = 500;

        } else {
            left = 30;
            top = 90;
        }


        $('.tap-to-open').css({
            'left' : left,
            'top' : top
        });
    }

    goToUrl(url) {
        $('.tap-to-open').addClass('tap-to-open__rotate');
        setTimeout(() => { $('.tap-to-open').removeClass('tap-to-open__rotate'); }, 220)

        window.open(url, '_blank');
            win.focus();
    }

    render() {
        console.log('project in tap to open', this.props.project)
        return (
            <img
                className='tap-to-open'
                id={this.state.uuid}
                src='/public/codi-studios/tap-to-vist.png'
                onClick={this.goToUrl.bind(this, this.props.project.url)} />
        );
    }
}

export default TapToOpen;



// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/TapToOpen.react.jsx